<style lang="scss">
.request-call-page {
  &__title {
    @include mobile-portrait() {
      margin-top: 25px !important;
    }
  }
}
</style>

<!-- eslint-disable -->
<template>
  <div class="col-12 request-call-confirm">
    <section class="request-call-page__title mb-3">
      <h2 class="font-weight-bolder mb-2">Confirm Request</h2>

      <h4>Please make sure all the details are correct before confirming your request.</h4>
    </section>

    <section>
      <h4>Your Establishment</h4>
      <p>{{prison.name}}</p>

      <h4>Date/Time</h4>
      <p>{{bookingDate}} @ {{bookingSlot.slot_begin}} - {{bookingSlot.slot_end}}</p>

      <h4>Booking Slot</h4>
      <p>{{bookingSlot.name}}</p>

      <h4>Contact</h4>
      <p>{{contact.firstname}} {{contact.lastname}}</p>
    </section>

    <section class="d-flex full-width mt-1" v-if="showNextButtons">
      <b-btn @click="$store.commit('requestCall/SET_STAGE', 3)" variant="outline-primary">Back</b-btn>
      <div class="ui-spacer"></div>
      <b-btn :class="{'disabled': loading}" @click="requestCall" variant="primary">Request Call</b-btn>
    </section>

    <b-modal id="modal-success-request" title="" hide-footer no-close-on-esc no-close-on-backdrop cancel-disabled hide-header-close>
      <warning-modal title="Video call Requested!"
                     note="Your video call has now been requested! Your call will show up in your call list if approved"
                     ok-variant="primary"
                     :ok-only="true"
                     @ok="goToCalls()"/>
    </b-modal>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import VisitsService from '@/services/VisitsService';
import { ERROR_CODES } from '@/util/errorCodes';
import WarningModal from '@/components/modals/WarningModal.vue';

export default {
  name: 'RequestCallConfirm',
  components: {
    WarningModal,
  },
  props: {
    showNextButtons: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.auth.prison,
      bookingDate: state => state.requestCall.booking.date,
      bookingSlot: state => state.requestCall.booking.bookingSlot,
      contact: state => state.requestCall.booking.contact,
      wing: state => state.requestCall.booking.wing,
    }),
  },
  mounted() {},
  methods: {
    requestCall() {
      this.loading = true;

      let dto = {
        visitor_user_id: this.contact.user_id,
        prison: {
          prison_id: this.prison.prison_id,
        },
        // eslint-disable-next-line no-underscore-dangle
        requested_booking_slot_1_id: this.bookingSlot._id,
        requested_booking_slot_1_date: this.bookingDate,
      };

      if (this.wing) {
        dto = {
          ...dto,
          // eslint-disable-next-line no-underscore-dangle
          wing_id: this.wing._id,
        }
      }

      VisitsService.requestCall(dto).then(() => {
        this.$bvModal.show('modal-success-request');
      }).catch(err => {
        let msg = 'Something went wrong booking the call, please refresh the page and try again';
        const errorExists = err && err.response && err.response.data && err.response.data.error;
        const error = errorExists ? err.response.data.error : null;

        if (error === ERROR_CODES.VISITOR.NOT_VERIFIED) {
          msg = 'Cannot book call as the you are not verified';
        } else if (error === ERROR_CODES.VISITOR.BANNED_ON_DATE) {
          msg = 'Cannot book call as your contact has been banned on the chosen booking slot'
        } else if (error === ERROR_CODES.VISIT_STOCK.NONE_LEFT) {
          msg = 'Cannot book call as the chosen booking slot has no stock left';
        } else if (error === ERROR_CODES.VISIT.PRISONER_BOOKED_ON_SLOT) {
          msg = 'Cannot book call as you are already booked on another call during the chosen booking slot';
        } else if (error === ERROR_CODES.PRISON.NOT_ENOUGH_FUND_TOKENS) {
          msg = 'Unable to fund call due to a lack of fund tokens.'
        } else if (error === ERROR_CODES.ADDITIONAL_VISITOR.NOT_VERIFIED) {
          msg = 'Unable to book with those additional participants as one or more is not marked as verified';
        } else if (error === ERROR_CODES.WINGS.WING_NOT_PROVIDED) {
          msg = 'Unable to book. Please select a wing.';
        } else if (error === ERROR_CODES.WINGS.WING_MUST_BE_ENABLED) {
          msg = 'Unable to book. Please refresh your page and select a wing that is enabled.';
        } else if (error === ERROR_CODES.WINGS.NO_WING_STOCK_LEFT) {
          msg = 'Unable to book. There is no stock left for the wing you have select. Refresh your page and choose a different wing.';
        } else if (error === ERROR_CODES.VISIT.VISIT_LIMIT_EXCEEDED) {
          msg = 'Cannot request visit as contact has exceeded their limit for the month';
        }

        this.$toast.error(msg, {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    goToCalls() {
      this.$bvModal.hide('modal-success-request');
      this.$router.push({ name: 'dashboard' });
    },
  },
}
</script>
